<template>
  <div class="overflow-auto">
    <table class="table">
      <thead>
        <tr>
          <th v-if="displayWeight" scope="col" class="p-2">{{ t("js.backend.ballot_summary.count_header") }}</th>
          <th scope="col" class="p-2">{{ t("js.backend.ballot_summary.voter_counts.total_eligibles") }}</th>
          <th scope="col" class="p-2">{{ t("js.backend.ballot_summary.voter_counts.active_eligibles_or_voted") }}</th>
          <th scope="col" class="p-2">{{ t("js.backend.ballot_summary.voter_counts.voted") }}</th>
          <th scope="col" class="p-2">{{ t("js.backend.ballot_summary.participation") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th v-if="displayWeight" scope="row" class="p-2">{{ t("js.backend.ballot_summary.voter_counts.by_individual") }}</th>
          <td class="p-2">{{ turnout.eligible }}</td>
          <td class="p-2">{{ turnout.present }}</td>
          <td class="p-2">{{ turnout.voted }}</td>
          <td class="p-2">{{ twoDecimalPercentage(turnout.voted, turnout.eligible ) }}</td>

        </tr>
        <tr v-if="displayWeight">
          <th scope="row" class="p-2">{{ t("js.backend.ballot_summary.voter_counts.by_weight") }}</th>
          <td class="p-2">{{ turnout.eligibleWeight }}</td>
          <td class="p-2">{{ turnout.presentWeight }}</td>
          <td class="p-2">{{ turnout.votedWeight }}</td>
          <td class="p-2">{{ twoDecimalPercentage(turnout.votedWeight, turnout.eligibleWeight) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import type { PropType, Turnout } from "@/types";

const { locale, t } = useI18n();

const props = defineProps({
  turnout: {
    type: Object as PropType<Turnout>,
    required: true,
  },
  hideWeight: {
    type: Boolean,
    default: false
  }
});

const weightDiff = computed(() => props.turnout.eligible != props.turnout.eligibleWeight);

const displayWeight = computed(() => !props.hideWeight && weightDiff.value);

const twoDecimalPercentage = (divisor: number, dividend: number) => {
  let fraction = divisor / dividend
  let config: Intl.NumberFormatOptions = {
    style: "percent",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }

  let formatter = new Intl.NumberFormat(locale.value, config);
  return formatter.format(fraction);
};
</script>

